var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
export var IconArrowLeft = function (_a) {
    var props = __rest(_a, []);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "none", viewBox: "0 0 20 20" }, props),
        React.createElement("path", { fill: "#196894", fillRule: "evenodd", d: "M10.025 2.475a.625.625 0 0 1 0 .883L4.01 9.375H17.5a.625.625 0 1 1 0 1.25H4.009l6.016 6.016a.625.625 0 1 1-.884.884l-7.083-7.083a.625.625 0 0 1 0-.884l7.083-7.083a.625.625 0 0 1 .884 0", clipRule: "evenodd" })));
};
